import { getStringHashCode26igk1bx568vk as getStringHashCode } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function _ServerFile___init__impl__jj3mn2(location) {
  return location;
}
function _ServerFile___get_location__impl__ddyqaq($this) {
  return $this;
}
function ServerFile__toString_impl_4rulpa($this) {
  return 'ServerFile(location=' + $this + ')';
}
function ServerFile__hashCode_impl_qj0ii5($this) {
  return getStringHashCode($this);
}
function ServerFile__equals_impl_4qpzf5($this, other) {
  if (!(other instanceof ServerFile()))
    return false;
  if (!($this === other.n2n_1))
    return false;
  return true;
}
var ServerFileClass;
function ServerFile() {
  if (ServerFileClass === VOID) {
    class $ {
      constructor(location) {
        this.n2n_1 = location;
      }
      toString() {
        return ServerFile__toString_impl_4rulpa(this.n2n_1);
      }
      hashCode() {
        return ServerFile__hashCode_impl_qj0ii5(this.n2n_1);
      }
      equals(other) {
        return ServerFile__equals_impl_4qpzf5(this.n2n_1, other);
      }
    }
    initMetadataForClass($, 'ServerFile');
    ServerFileClass = $;
  }
  return ServerFileClass;
}
//region block: exports
export {
  ServerFile as ServerFile1t91jzpzoixwe,
  _ServerFile___init__impl__jj3mn2 as _ServerFile___init__impl__jj3mn23p0pea18kbfe7,
  ServerFile__hashCode_impl_qj0ii5 as ServerFile__hashCode_impl_qj0ii515d8xjm2d7n5l,
  _ServerFile___get_location__impl__ddyqaq as _ServerFile___get_location__impl__ddyqaq3o0wsfuapqiy2,
  ServerFile__toString_impl_4rulpa as ServerFile__toString_impl_4rulpa1zv5xkbnowbd9,
};
//endregion

//# sourceMappingURL=ServerFile.mjs.map
